/**
 * Form System Configuration
 * 
 * Route-to-service mapping and form constants for XperfoMax
 */

// Route to service mapping for auto-selection
export const routeServiceMap: Record<string, string> = {
  '/seo': 'SEO',
  '/paid-marketing': 'Paid Marketing',
  '/paid-search': 'Paid Marketing',
  '/paid-social': 'Paid Marketing',
  '/programmatic': 'Programmatic',
  '/email-marketing': 'Not sure yet',
  '/cro': 'CRO',
  '/analytics': 'Analytics',
  '/ai-automation': 'Data Infrastructure',
  '/web-development': 'Web Development',
  '/data-management': 'Data Infrastructure',
  '/ux-strategy': 'UX Strategy',
  '/google-cloud-platform': 'Data Infrastructure',
  '/affiliate-marketing': 'Paid Marketing',
  '/media-activations': 'Paid Marketing',
  // Solution pages
  '/solutions': 'Ecommerce Growth',
  '/solutions/ecommerce-growth': 'Ecommerce Growth',
  '/solutions/saas-acceleration': 'SaaS Acceleration',
  '/solutions/d2c-scale': 'D2C Scale',
  '/solutions/enterprise-performance': 'Enterprise Performance',
  // Analytics sub-pages
  '/analytics/attribution-modeling': 'Attribution',
  '/analytics/ga4-implementation': 'Analytics',
};

// Service options grouped by category for dropdown
export const serviceOptionsGrouped = {
  'Growth Systems': [
    'Ecommerce Growth',
    'SaaS Acceleration',
    'D2C Scale',
    'Enterprise Performance',
  ],
  'Performance Marketing': [
    'Paid Marketing',
    'SEO',
    'Programmatic',
  ],
  'Analytics & Intelligence': [
    'Analytics',
    'Attribution',
    'Data Infrastructure',
  ],
  'Web & CRO': [
    'CRO',
    'Web Development',
    'UX Strategy',
  ],
  'Other': [
    'Not sure yet',
  ],
};

// Flat service options for validation
export const serviceOptions = Object.values(serviceOptionsGrouped).flat();

// Role options
export const roleOptions = [
  'Founder / CEO',
  'CMO / Marketing Director',
  'VP Marketing',
  'Head of Growth',
  'Marketing Manager',
  'Digital Marketing Lead',
  'Performance Marketer',
  'Product Manager',
  'Other',
];

// Budget range options
export const budgetOptions = [
  'Under $5,000/month',
  '$5,000 - $15,000/month',
  '$15,000 - $50,000/month',
  '$50,000 - $100,000/month',
  '$100,000+/month',
  'Prefer to discuss',
];

// Timeline options
export const timelineOptions = [
  'Immediate (within 2 weeks)',
  '30 days',
  '60 days',
  '90 days',
  'No specific timeline',
];

// Challenge options for discovery form
export const challengeOptions = [
  'Customer acquisition cost too high',
  'Scaling profitably',
  'Attribution and measurement',
  'Creative performance',
  'Technical infrastructure',
  'Team capacity',
  'Strategic direction',
  'Other',
];

// Analytics tools options
export const analyticsToolOptions = [
  'Google Analytics 4',
  'Google Tag Manager',
  'Segment',
  'Mixpanel',
  'Amplitude',
  'Heap',
  'Adobe Analytics',
  'Looker / Data Studio',
  'Other',
];

// Audit focus options
export const auditFocusOptions = [
  'Tracking implementation',
  'Attribution modeling',
  'Dashboard and reporting',
  'Data quality',
  'Conversion optimization',
  'Full marketing analytics audit',
];

// Partnership type options
export const partnershipTypes = [
  'Technology partnership',
  'Agency referral',
  'Strategic collaboration',
  'Speaking / Events',
  'Content collaboration',
  'Other',
];

// Career roles
export const careerRoles = [
  'Performance Marketing',
  'SEO Specialist',
  'Analytics Engineer',
  'CRO Specialist',
  'Account Director',
  'Project Manager',
  'Other',
];

// Pages that should NOT auto-select service
export const noAutoSelectPaths = [
  '/',
  '/about',
  '/resources',
  '/blog',
  '/guides',
  '/career',
  '/contact',
  '/faqs',
];
